import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Payment } from "./payment";
import {catchError} from "rxjs/operators";
import {PaymentFormComponent} from "./payment-form/payment-form.component";
import {Customer} from "./customer";
import {CustomerFormComponent} from "./customer-form/customer-form.component";
import {CustomerListComponent} from "./customer-list/customer-list.component";
import {PaymentListComponent} from "./payment-list/payment-list.component";

@Injectable()
export class PaymentService {

  private paymentsUrl: string;

  constructor(private http: HttpClient) {
    this.paymentsUrl = window.location.protocol + "//" + window.location.hostname + "/payments";
  }

  public findAll(): Observable<Payment[]> {
    return this.http.get<Payment[]>(this.paymentsUrl);
  }

  public findById(id: string): Observable<Payment> {
    return this.http.get<Payment>(this.paymentsUrl + '/' + id);
  }

  public findAllByInvoiceId(id2: string): Observable<Payment[]> {
    return this.http.get<Payment[]>(this.paymentsUrl + '/invoice/' + id2);
  }

  public delete(id: string) {
    return this.http.delete(this.paymentsUrl + '/' + id);
  }

  public save(invoice: Payment, form: PaymentFormComponent) {
    return this.http.post<Payment>(this.paymentsUrl, invoice).pipe(catchError((error: HttpErrorResponse) => {
      let errorMessage = '';
      if (error.error instanceof ErrorEvent) {
        errorMessage = `${error.error.message}`;
      } else {
        errorMessage = `${error.error} (status: ${error.status})\n`;
      }
      form.myError = errorMessage;
      //window.alert(errorMessage);
      return undefined;
    }));
  }

  public update(invoice: Payment, form: PaymentFormComponent) {
    return this.http.put(this.paymentsUrl, invoice).pipe(catchError((error: HttpErrorResponse) => {
      let errorMessage = '';
      if (error.error instanceof ErrorEvent) {
        errorMessage = `${error.error.message}`;
      } else {
        errorMessage = `${error.error} (status: ${error.status})\n`;
      }
      form.myError = errorMessage;
      //window.alert(errorMessage);
      return undefined;
    }));
  }

}



// WEBPACK FOOTER //
// ./src/app/payment-service.service.ts